import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/styles/border.css'
import './assets/styles/reset.css'
import  SvgIcon from '@/icons' // svg图标组件
import '@/router/permission.js'

document.title = "爱情小屋音乐播放器运维平台";
createApp(App).use(store).use(router).use(ElementPlus).use(SvgIcon).mount('#app')
const app = createApp(App);

app.use(router);


const LOCAL_VERSION = process.env.VUE_APP_VERSION  // 打包时注入的 package.json 版本

/* 2. 全局注册 */
app.component('Plus', Plus)   // 关键：把 Plus 注册成全局组件

app.use(ElementPlus).mount('#app')



// fetch('/version.json', { cache: 'no-store' })      // 每次都不走缓存
//   .then(r => r.json())                             // 返回 "0.1.2"
//   .then(remote => {
//     if (remote !== LOCAL_VERSION) {
//       // 服务器版本更新 → 强制刷新
//       location.replace(location.href)
//     }
//   })
//   .catch(() => {
//     /* 拉不到就放弃，不做任何处理 */
//   })


//监听路由变化，如果路径为空，则条状/login
// router.beforeEach((to, from, next) => {
//   if (to.path === '/') {
//     next('/login');
//   } else {
//     next();
//   }
// });

